import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router'
import { useLocation } from 'react-router-dom'
import { makeRequest } from '../apis/makeRequest'
import { notificationActions } from '../actions/notificationActions'
import { resetPassword } from '../apis/accountRequests'
import { useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import { forgotPasswordSchema } from '../validation/forgotPasswordSchema'
import { theme } from "../ui/theme"
import { Container, Typography, Button, Avatar } from '@mui/material'
import { FormTextField } from '../controls'
import VpnKeyIcon from '@mui/icons-material/VpnKey'

const styles = {
    paper: {
        marginTop: theme.spacing(5),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    form: {
        width: '100%',
        marginTop: theme.spacing(1),
    },
    avatar: {
        margin: theme.spacing(1),
        backgroundColor: theme.palette.secondary.main,
    },
    submit: {
        margin: theme.spacing(1, 0, 1),
        backgroundColor: "#B5CD7F",
        '&:hover': {
            backgroundColor: "#8BB85A",
        },
        color: "black"
    },
}

const fields = forgotPasswordSchema.describe().fields

export default function ForgotPassword() {

    const dispatch = useDispatch()
    const search = useLocation().search
    const navigate = useNavigate()
    const [formData, setformData] = useState(null)

    const { control, handleSubmit, formState: { errors } } = useForm({
        resolver: yupResolver(forgotPasswordSchema),
        reValidateMode: 'onBlur'
    })

    useEffect(() => {
        if (!search && !formData) {
            dispatch(notificationActions.showError({ message: "Url invalida o expirada" }))
            navigate("/login")
        }
        let searchParams = new URLSearchParams(search)
        let values = {
            userName: searchParams.get('userName'),
            token: searchParams.get('token'),
        }
        setformData(values)
    }, [search])


    const onSubmit = data => {
        data.UserName = formData.userName
        data.Token = formData.token

        makeRequest(
            () => resetPassword(data),
            res => {
                dispatch(notificationActions.showSuccess({ message: 'Se cambio correctamente la contraseña' }))
                navigate('/login')
            },
            err => dispatch(notificationActions.showError({ message: 'Cambio de contraseña expirado o contraseña invalida' }))
        )
    }

    return (
        <Container component='main' maxWidth='xs'>
            <div style={styles.paper}>
                <Avatar sx={styles.avatar}>
                    <VpnKeyIcon />
                </Avatar>
                <Typography component='h1' variant='h5'>Nueva contraseña</Typography>
                <form style={styles.form} onSubmit={handleSubmit(onSubmit)}>
                    <FormTextField name='NewPassword' type='password' margin='dense' size='small'
                        style={{ width: "100%" }} control={control} schema={fields.NewPassword} formErrors={errors.NewPassword}
                    />
                    <FormTextField name='passwordConfirm' type='password' margin='dense' size='small'
                        style={{ width: "100%" }} control={control} schema={fields.passwordConfirm} formErrors={errors.passwordConfirm}
                    />
                    <Typography variant='caption'>
                        Utiliza 6 caracteres como mínimo,incluyendo una letra mayúscula, minúscula y un carácter no alfanumérico.
                    </Typography>
                    <Button fullWidth sx={styles.submit} type='submit'>Cambio de contraseña</Button>
                </form>
            </div>
        </Container>
    )
}